import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Marcela', 'Carolina', 'Fernando', 'Sofía', 'Diego', 'Claudia', 'Martín', 'Lucía', 'Gabriela', 'Pablo', 'Romina', 'Federico', 'Valeria', 'Andrés', 'Natalia'];
const CITIES = ['Buenos Aires', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan', 'Paraná'];
export const FloatingElements = () => {
  const [popupData, setPopupData] = useState<{
    name: string;
    city: string;
    time: number;
  } | null>(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  // Handle popup rotation
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 14) + 1;
      setPopupData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsPopupVisible(true);
      setTimeout(() => {
        setIsPopupVisible(false);
      }, 5000);
    };
    // First popup fires ~30s after landing, then every 30s.
    const initialTimer = setTimeout(triggerPopup, 30000);
    const interval = setInterval(triggerPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isPopupVisible && popupData && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 max-w-xs flex items-start gap-3" data-id="element-2">
          <div className="bg-green-100 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-3">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-4" />
          </div>
          <div className="flex-1 pr-4" data-id="element-5">
            <p className="text-sm text-gray-800 leading-tight" data-id="element-6">
              <span className="font-bold" data-id="element-7">{popupData.name}</span> de{' '}
              {popupData.city} compró{' '}
              <span className="font-bold text-brand-700" data-id="element-8">Megapack Élite</span>
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-9">
              hace {popupData.time} minutos
            </p>
          </div>
          <button onClick={() => setIsPopupVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-10">
            <X className="w-4 h-4" data-id="element-11" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};